<template>
  <el-drawer
    title="订单详情"
    :visible.sync="drawerVisible"
    direction="rtl"
    size="70%"
    custom-class="order-drawer"
  >
    <h4>订单信息</h4>
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="12" v-for="(item, index) in baseInfo" :key="index"
          ><p class="list">{{ item.name }}: {{ item.value }}</p></el-col
        >
        <el-col :span="24">
          <div class="btn-box">
            <el-button type="primary" @click="$refs.consume.handleConsume(sn, can_consume)"
              >核单</el-button
            >
            <el-button type="primary" @click="$refs.edit.handleEdit(sn)">修改订单</el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <h4>产品信息</h4>
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="12" v-for="(item, index) in productInfo" :key="index"
          ><p class="list">{{ item.name }}: {{ item.value }}</p></el-col
        >
      </el-row>
    </el-card>

    <h4>出行信息</h4>
    <Table :data="passengers" :columns="passengersColumns">
      <template v-slot:age_type>
        <el-table-column label="人群" width="100" align="center">
          <template slot-scope="scope">
            {{
              scope.row.age_type === 'ADU'
                ? ' 成人'
                : scope.row.age_type === 'CHI'
                ? '儿童'
                : '婴儿'
            }}
          </template>
        </el-table-column>
      </template>
    </Table>
    <template v-if="cancel_records.length > 0">
      <h4>退订记录</h4>
      <Table :data="cancel_records" :columns="cancelRecordsColumns">
        <template v-slot:age_type>
          <el-table-column label="人群" width="100" align="center">
            <template slot-scope="scope">
              {{
                scope.row.age_type === 'ADU'
                  ? ' 成人'
                  : scope.row.age_type === 'CHI'
                  ? '儿童'
                  : '婴儿'
              }}
            </template>
          </el-table-column>
        </template>
      </Table>
    </template>

    <Edit ref="edit" />
    <Consume ref="consume" />
  </el-drawer>
</template>

<script>
import { getDetail } from '@/api/orders'
import Edit from '@/views/orders/components/Edit'
import Consume from '@/views/orders/components/Consume'
export default {
  name: 'OrderDrawer',
  components: { Edit, Consume },
  computed: {},
  props: {},
  data() {
    return {
      drawerVisible: false,
      sn: '',
      can_consume: '',
      baseInfo: [],
      productInfo: [],
      passengers: [],
      passengersColumns: [
        {
          label: '姓名',
          width: '120',
          prop: 'name',
          align: 'center'
        },
        {
          label: '身份证',
          width: '160',
          prop: 'card_no',
          align: 'center'
        },
        {
          label: '人群',
          slot: 'age_type'
        },
        {
          label: '手机号',
          width: '160',
          prop: 'mobile',
          align: 'center'
        },
        {
          label: '出生日期',
          minWidth: '140',
          prop: 'birth_date',
          align: 'center'
        }
      ],
      cancel_records: [],
      cancelRecordsColumns: [
        {
          label: '退订资源',
          width: '180',
          prop: 'product_name',
          showOverflowTooltip: true
        },
        {
          label: '退订数量',
          width: '160',
          prop: 'quantity',
          align: 'center'
        },

        {
          label: '实退总额',
          width: '160',
          prop: 'amount',
          align: 'center'
        },
        {
          label: '申请时间',
          minWidth: '140',
          prop: 'add_time',
          align: 'center'
        },
        {
          label: '原因',
          width: '140',
          prop: '',
          showOverflowTooltip: true
        },
        {
          label: '状态',
          minWidth: '140',
          prop: '',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    handleDetail(sn) {
      const _this = this
      _this.sn = sn
      _this.drawerVisible = true
      getDetail(sn).then((res) => {
        const data = res.data
        _this.can_consume = res.data.can_consume

        _this.baseInfo = [
          { name: '订单编号', value: data.ota_sn },
          { name: '派单状态', value: data.assign_status === 1 ? '未派单' : '已派单' },
          {
            name: '订单来源',
            value: _this.$platform[data.source]
          },
          { name: '导游姓名', value: data.guide && data.guide.name },
          {
            name: '订单状态',
            value: [
              '',
              '待核单',
              '已核单',
              '已取消',
              '买家已付款',
              '卖家已发货',
              '交易成功',
              '交易关闭'
            ][data.order_status]
          },
          { name: '导游手机', value: data.guide && data.guide.mobile },
          { name: '订单总额', value: `${data.price}元` },
          { name: '下单时间', value: data.pay_time }
        ]

        _this.productInfo = [
          { name: '产品名称', value: data.product_name },
          { name: '套餐名称', value: data.package_name },
          { name: '产品数量', value: data.user_num },
          { name: '单价', value: `${data.unit_price}元` },
          { name: '联系人', value: `${data.contact.name} / ${data.contact.mobile}` },
          { name: '出行日期', value: data.use_date },
          { name: '场次', value: data.interval_time }
        ]
        _this.passengers = data.passengers
        _this.cancel_records = data.cancel_records
      })
    }
  }
}
</script>
<style scoped lang="less">
/deep/ .order-drawer {
  box-sizing: border-box;
  padding: 10px 20px;
}
/deep/ .el-drawer__header {
  font-size: 16px;
  font-weight: bold;
  padding-left: 0;
  color: #333;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 0;
  padding-bottom: 20px;
}
.list {
  height: 40px;
  line-height: 40px;
}
.btn-box {
  display: flex;
  justify-content: center;
  .el-button {
    font-weight: bold;
  }
}
</style>
